<template>
  <div class="about">
    <Section medium>
      <v-col cols="12" md="10" class="mx-auto">
        <div class="about-card reveal">
          <div class="accent" />
          <div class="body">
            <h1>About Yonder Dynamics</h1>
            <p>
              Yonder Dynamics is a student robotics organization at UC San Diego
              formally established in Fall 2016. As our primary project, we
              design and build a Mars rover for the annual University Rover
              Challenge (URC), a prestigious international competition for
              college students. Our newest rover, Contingency, placed 19th of 114
              teams in the world overall at the 2025 URC world finals.
              Our team qualified for this competition by demonstrating Contingency
              in the following video submission:
            </p>
            <div class="video-wrap">
              <div class="video-container">
                <iframe
                  class="video"
                  src=""
                  data-src="https://www.youtube.com/embed/8XUT9da2txI?si=9xo001DjHbiDdvAC"
                  frameborder="0"
                  allow="autoplay; encrypted-media"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </Section>

    <div class="reveal">
      <SplitSection medium>
        <template v-slot:left>
          <h1>URC</h1>
          <p>
            The University Rover Challenge (URC) is the world's premier
            robotics competition for university students. Held annually at the
            Mars Desert Research Station (MDRS), URC challenges student teams to
            design and build the next generation of Mars rovers that will one
            day work alongside astronauts exploring the Red Planet.
          </p>
        </template>
        <template v-slot:right>
          <v-img class="shrink mr-2" contain :src="require('@/assets/urc.jpg')" />
        </template>
      </SplitSection>
    </div>
  </div>
</template>

<script>
import Section from '@/components/Section.vue';
import SplitSection from '@/components/SplitSection.vue';

export default {
  name: 'About',
  components: { Section, SplitSection },
  mounted() {
    const vidDefer = this.$el.getElementsByTagName('iframe');
    for (let i = 0; i < vidDefer.length; i += 1) {
      if (vidDefer[i].getAttribute('data-src')) {
        vidDefer[i].setAttribute('src', vidDefer[i].getAttribute('data-src'));
      }
    }
    // reveal effects
    const els = this.$el.querySelectorAll('.reveal');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.15 },
    );
    els.forEach((el) => io.observe(el));
  },
};
</script>

<style scoped>
.video-container { position: relative; overflow: hidden; height: 0; padding-bottom: 56.25%; }
.video-wrap { width: 100%; max-width: 1000px; margin: 16px auto 0; }
.video { position: absolute; top: 0; left: 0; width: 100%; height: 100%; max-height: 100%; }

/* Card styling like Projects */
.about-card {
  display: grid;
  grid-template-columns: 6px 1fr;
  background: var(--light);
  color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.35);
  transition: transform 250ms ease, box-shadow 250ms ease;
}
.about-card:hover { transform: translateY(-2px); box-shadow: 0 14px 36px rgba(0,0,0,0.45); }
.accent { background: linear-gradient(180deg, #8b7bd9, var(--medium)); }
.body { padding: 20px 22px; }
.reveal { opacity: 0; transform: translateY(12px); }
.reveal.visible { opacity: 1; transform: translateY(0); transition: all 500ms ease; }
</style>
